(function () {
  /**
   * Sets src on all img[data-proxy-id] elements and data-src on parent
   * .product__media-item[data-proxy-id] elements (for PhotoSwipe zoom).
   * Call with a root element to scope the update (e.g. after quick-view loads).
   */
  function loadProxyImages(root) {
    var base = window.FoxTheme && (window.FoxTheme.proxyBase || '').trim();
    if (!base || base === 'REPLACE_WITH_PROXY_BASE_URL') return;

    // Set src on proxy image tags
    root.querySelectorAll('img[data-proxy-id]').forEach(function (img) {
      if (!img.dataset.proxyLoaded) {
        img.src = base + '?id=' + img.dataset.proxyId;
        img.dataset.proxyLoaded = '1';
      }
    });

    // Set data-src on gallery viewer items for PhotoSwipe
    root.querySelectorAll('.product__media-item[data-proxy-id]').forEach(function (el) {
      el.dataset.src = base + '?id=' + el.dataset.proxyId;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadProxyImages(document);
    });
  } else {
    loadProxyImages(document);
  }

  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.loadProxyImages = loadProxyImages;
})();
